<template>
    <modal
        :class="modalClass"
        :name="modalName"
        :clickToClose="false"
        @before-open="beforeOpen"
        @opened="opened"
        @closed="closed">

        <a class="modal__close" @click="closeModal"></a>

        <slot></slot>
    </modal>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import vmodal from 'vue-js-modal';

    Vue.use(vmodal);

    @Component({
        props: {
            modalName: String,
            modalClass: String
        }
    })
    export default class ModalWrapper extends Vue {
        name = 'modal-wrapper';

        beforeOpen(event) {
            document.getElementsByTagName('body')[0].className += ' modal__open';
            this.$emit('before-open', event);
        }

        opened(event) {
            this.modalOpen = true;
            this.$emit('modalIsOpen', this.modalOpen);
        }

        closed(event){
            document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className.replace('modal__open', '');
            this.modalOpen = false;
            this.$emit('modalWasClosed', this.modalOpen);
        }

        // Also remove the fixed class when the modal is forced destroyed: parent element destroyed, etc.
        beforeDestroy() {
            this.closed();
        }

        closeModal() {
            this.$modal.hide(this.modalName);
        }
    }

    Vue.component('modal-wrapper', ModalWrapper);
</script>



// WEBPACK FOOTER //
// src/components/general/ModalWrapper.vue